import { t } from "@web-monorepo/i18n/macro";
import { DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import styles from "./ToolkitCard.module.css";

type ToolkitCardProps = React.PropsWithChildren<{
  close?: VoidFunction;
}>;

export default function ToolkitCard({ children, close }: ToolkitCardProps) {
  return (
    <div className={styles.card}>
      {close && (
        <div className={styles.closeButton}>
          <DDSIconButton
            variant="tertiary"
            aria-label={t`Close`}
            data-name="toolkit_card:close"
            tooltip={{ content: t`Close`, dataName: "toolkit_card:close:tooltip" }}
            onClick={close}
          >
            <IconX />
          </DDSIconButton>
        </div>
      )}
      {children}
    </div>
  );
}
